module.exports = __webpack_public_path__ + "static/AboutUs-Hero-Graphics_v4-1290306d8180b46b174bfff4dd9b6de7.svg";